import { ContactBalanceQueryProps } from '@features/contactBalance'

import { QueryKeys } from '../../../enums/queryKeys'

export const getCreditorsQueryKey = (queryProps: ContactBalanceQueryProps): [QueryKeys, ContactBalanceQueryProps] => [
  QueryKeys.Creditors,
  queryProps,
]
